// extracted by mini-css-extract-plugin
export var phone = "_2u-0";
export var phoneDragging = "_2u-1";